import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import apiHandler from "../../common/api";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import moment from "moment";
import DatePickup from "../../components/DatePickup/DatePickup";
import { imgpathgenerator } from "../../../core/Common/imgpathgenerator";

const BusinessListingMaster = () => {
  //const Parms = useParams();
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const ID = localStorage.getItem("ID");
  const Parms = useParams();
  const location = useLocation();
  const parts = location.pathname;
  let pathname = parts?.trim()?.split("/");

  const route = all_routes;
  const dispatch = useDispatch();
  // const ID = localStorage.getItem("ID");

  const data = useSelector((state) => state.toggle_header);
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const Yesterday = moment().subtract(1, "days").toDate();
  const [formvalue, setFormValue] = useState({
    businessName: "",
    businessLogoUrl: "",
    businessCategory: "",
    businessDescription: "",
    businessAddress: "",
    openingDate: Yesterday,
    serviceArea: "",
    shortLink: "",
    qrCodeUrl: "",
    linkedBusinessId: 0,
    phoneNumber: "",
    email: "",
    whatsappNumber: "",
    websiteUrl: "",
    googleMapUrl: "",
    menuUrl: "",
    appointmentUrl: "",
    onlineOrderingUrl: "",
    termsAndCondition: "",
    healthAndSafetyAttribute: "",
    accessibilityFeatures: "",
  });

  const [Categorylist, setCategoryList] = useState([]);

  const HandleChange = (e, field) => {
    if (field) {
      setFormValue({ ...formvalue, [field]: e.target.value });
    } else {
      const { name, value } = e.target;
      setFormValue({ ...formvalue, [name]: value });
    }
  };

  const handleDateChange = (e) => {
    console.log(e, "selectedDate");
    if (e) {
      setFormValue(
        {
          ...formvalue,
          ["openingDate"]: e,
        }
        // ...prevState.slice(1),
      );
    }
  };

  const HandleFileChange = (e) => {
    const file = e.target.files[0];
    console.log(file, "789654");

    setFormValue(
      {
        ...formvalue,
        ["businessLogoUrl"]:
        imgpathgenerator(file.name, pathname[1])|| "",
        dirname: `${pathname[1]}`,
        file: file,
      }
      // ...prevState.slice(1),
    );
  };

  console.log(formvalue, "formvalue");
  const HandleSubmit = async (e) => {
    e.preventDefault();

    const response = await apiHandler({
      method: "POST",
      route: "Superadmin/BusinessListingMasterUpsert",
      payload: { ...formvalue, loginUserId: ID },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.ResponseCode === "SUCCESS") {
      MySwal.fire({
        title: "Upsert!",
        text: "Your file has been Upsert.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
      navigate(route.BusinessListingMaster);
    }
  };

  const productDataListApi = async () => {
    if (Parms?.id > 0) {
      const response = await apiHandler({
        method: "GET",
        route: `Superadmin/ModuleFindId?Module=BusinessListingMaster&&ID=${Parms?.id}`,
      });
      if (response.ResponseCode === "SUCCESS") {
        console.log(response, "data");
        setFormValue(response.ResponseData[0]);
      } else {
        console.log(response, "data");
      }
    }
    const response = await apiHandler({
      method: "GET",
      route: "Business/CategoryAll",
    });
    if (response.ResponseCode === "SUCCESS") {
      setCategoryList(response.ResponseData);
    }
  };

  useEffect(() => {
    productDataListApi();
  }, []);

  const categoryOptions = Categorylist?.map((u) => ({
    value: u.ID,
    label: u.categoryName,
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Business Listing Master</h4>
              <h6>Create new Business Listing Master</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link
                  to={route.BusinessListingMaster}
                  className="btn btn-secondary"
                >
                  <ArrowLeft className="me-2" />
                  Back to Business Listing Master
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <form onSubmit={HandleSubmit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div
                className="accordion-card-one accordion"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />{" "}
                          <span>Business Listing Master Information</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Business Name</label>
                            <input
                              type="text"
                              name="businessName"
                              value={formvalue.businessName}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Business Logo URL
                            </label>
                            <input
                              type="file"
                              name="businessLogoUrl"
                              // value={formvalue.businessLogoUrl}
                              onChange={(e) => HandleFileChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Business Category
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              options={categoryOptions}
                              name="businessCategory"
                              value={categoryOptions?.find(
                                (el) => el.value === formvalue.businessCategory
                              )}
                              onChange={(e) =>
                                HandleChange({
                                  target: {
                                    name: "businessCategory",
                                    value: e.value,
                                  },
                                })
                              }
                              placeholder="Choose Category"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Business Description
                            </label>
                            <textarea
                              name="businessDescription"
                              value={formvalue.businessDescription}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Business Address
                            </label>
                            <input
                              type="text"
                              name="businessAddress"
                              value={formvalue.businessAddress}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Opening Date</label>
                            <DatePickup
                              filterDate={formvalue.openingDate}
                              handleDateChange={(e) => handleDateChange(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Service Area</label>
                            <input
                              type="text"
                              name="serviceArea"
                              value={formvalue.serviceArea}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Short Link</label>
                            <input
                              type="text"
                              name="shortLink"
                              value={formvalue.shortLink}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">QR Code URL</label>
                            <input
                              type="text"
                              name="qrCodeUrl"
                              value={formvalue.qrCodeUrl}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Linked Business ID
                            </label>
                            <input
                              type="number"
                              name="linkedBusinessId"
                              value={formvalue.linkedBusinessId}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Phone Number</label>
                            <input
                              type="number"
                              name="phoneNumber"
                              value={formvalue.phoneNumber}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Email</label>
                            <input
                              type="email"
                              name="email"
                              value={formvalue.email}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              WhatsApp Number
                            </label>
                            <input
                              type="number"
                              name="whatsappNumber"
                              value={formvalue.whatsappNumber}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Website URL</label>
                            <input
                              type="text"
                              name="websiteUrl"
                              value={formvalue.websiteUrl}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Google Map URL</label>
                            <input
                              type="text"
                              name="googleMapUrl"
                              value={formvalue.googleMapUrl}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Menu URL</label>
                            <input
                              type="text"
                              name="menuUrl"
                              value={formvalue.menuUrl}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Appointment URL
                            </label>
                            <input
                              type="text"
                              name="appointmentUrl"
                              value={formvalue.appointmentUrl}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Online Ordering URL
                            </label>
                            <input
                              type="text"
                              name="onlineOrderingUrl"
                              value={formvalue.onlineOrderingUrl}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Terms and Condition
                            </label>
                            <textarea
                              name="termsAndCondition"
                              value={formvalue.termsAndCondition}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Health and Safety Attribute
                            </label>
                            <textarea
                              name="healthAndSafetyAttribute"
                              value={formvalue.healthAndSafetyAttribute}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Accessibility Features
                            </label>
                            <textarea
                              name="accessibilityFeatures"
                              value={formvalue.accessibilityFeatures}
                              onChange={(e) => HandleChange(e)}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                Save Business Listing Master
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BusinessListingMaster;
